import cs from "./locales/cs.json";
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import frCa from "./locales/fr-CA.json";
import it from "./locales/it.json";
import ko from "./locales/ko.json";
import ml from "./locales/ml.json";
import pl from "./locales/pl.json";
import pt from "./locales/pt.json";
import ptBr from "./locales/pt-BR.json";
import ru from "./locales/ru.json";
import sv from "./locales/sv.json";
import tr from "./locales/tr.json";
import uk from "./locales/uk.json";
import zhHans from "./locales/zh-Hans.json";

export const resources = {
  cs: { translation: cs },
  de: { translation: de },
  "en-US": { translation: en },
  "es-ES": { translation: es },
  fr: { translation: fr },
  "fr-CA": { translation: frCa },
  it: { translation: it },
  ko: { translation: ko },
  ml: { translation: ml },
  pl: { translation: pl },
  pt: { translation: pt },
  "pt-BR": { translation: ptBr },
  ru: { translation: ru },
  sv: { translation: sv },
  tr: { translation: tr },
  uk: { translation: uk },
  "zh-Hans": { translation: zhHans },
};

export const languages = [
  {
    nativeName: "Čeština",
    langCode: "cs",
    flag: "CZ",
    dayjsLocale: "cs",
  },
  {
    nativeName: "Deutsch",
    langCode: "de",
    flag: "DE",
    dayjsLocale: "de",
  },
  {
    nativeName: "English (US)",
    langCode: "en-US",
    flag: "US",
    dayjsLocale: "en",
  },
  {
    nativeName: "Español (España)",
    langCode: "es-ES",
    flag: "ES",
    dayjsLocale: "es",
  },
  {
    nativeName: "Français",
    langCode: "fr",
    flag: "FR",
    dayjsLocale: "fr",
  },
  {
    nativeName: "Français (Canada)",
    langCode: "fr-CA",
    flag: "CA",
    dayjsLocale: "fr-ca",
  },
  {
    nativeName: "Italiano",
    langCode: "it",
    flag: "IT",
    dayjsLocale: "it",
  },
  {
    nativeName: "한국어",
    langCode: "ko",
    flag: "KR",
    dayjsLocale: "ko",
  },
  {
    nativeName: "മലയാളം",
    langCode: "ml",
    flag: "IN",
    dayjsLocale: "ml",
  },
  {
    nativeName: "Polski",
    langCode: "pl",
    flag: "PL",
    dayjsLocale: "pl",
  },
  {
    nativeName: "Português (Portugal)",
    langCode: "pt",
    flag: "PT",
    dayjsLocale: "pt",
  },
  {
    nativeName: "Português (Brasil)",
    langCode: "pt-BR",
    flag: "BR",
    dayjsLocale: "pt-br",
  },
  {
    nativeName: "Русский",
    langCode: "ru",
    flag: "RU",
    dayjsLocale: "ru",
  },
  {
    nativeName: "Svenska",
    langCode: "sv",
    flag: "SE",
    dayjsLocale: "sv",
  },
  {
    nativeName: "Türkçe",
    langCode: "tr",
    flag: "TR",
    dayjsLocale: "tr",
  },
  {
    nativeName: "Українська",
    langCode: "uk",
    flag: "UA",
    dayjsLocale: "uk",
  },
  {
    nativeName: "简体中文",
    langCode: "zh-Hans",
    flag: "CN",
    dayjsLocale: "zh-cn",
  },
];
